<div class="inbuilt-visual">
    <div class="inbuilt-visual__header">
        <span class="inbuilt-visual__icon">
            <mat-icon aria-hidden="true">bar_chart</mat-icon>
        </span>
        <h2 class="inbuilt-visual__title">Add visual</h2>
    </div>
    <p class="inbuilt-visual__description">
        Choose a chart, table, or metric to turn the filtered data into a report component.
    </p>
    <div class="inbuilt-visual__action">
        <button type="button" class="inbuilt-visual__button" (click)="addVisual.emit()">
            <mat-icon aria-hidden="true">add</mat-icon>
            <span>Add visual</span>
        </button>

        <div class="inbuilt-visual__menu" *ngIf="showVisualMenu">
            <button type="button" class="inbuilt-visual__menu-item" *ngFor="let option of visualTypeOptions"
                (click)="visualTypeSelected.emit(option)">
                <mat-icon class="inbuilt-visual__menu-icon" aria-hidden="true">{{ option.icon }}</mat-icon>
                <span class="inbuilt-visual__menu-text">
                    <span class="inbuilt-visual__menu-label">{{ option.label }}</span>
                    <span class="inbuilt-visual__menu-description">{{ option.description }}</span>
                </span>
            </button>
        </div>
    </div>
</div>
